<template>
  <li class="carousel__item">
    <b-overlay :show="loading || error" rounded="sm">
      <template #overlay>
        <p v-if="loading" class="text-center text-muted fs-19 mb-0">
          Consultando datos
        </p>
        <div v-if="!loading && error" class="fs-19"></div>
      </template>
      <div
        @click="$emit('open-detail-modal')"
        class="card-dashboard"
        :class="[loading ? 'loading' : '', badgeColor]"
      >
        <div class="card-dashboard-content">
          <div class="card-dashboard-header">
            <div class="card-dashboard-icon">
              <font-awesome-icon class="icon" :icon="icon" fixed-width />
            </div>
            <div class="card-dashboard-info">
              <div class="card-dashboard-title-row">
                <h3 class="card-dashboard-title">{{ title }}</h3>
                <sup v-show="badge" class="card-dashboard-badge"> {{ badge }} </sup>
              </div>
              <p class="card-dashboard-value">
                <span v-if="loading">0</span>
                <span v-else>{{ value }}</span>
              </p>
              <p class="card-dashboard-subtext">{{ description }}</p>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </li>
</template>

<script>
export default {
  name: 'DashboardCard',
  props: {
    icon: {
      type: [String, Array],
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    badge: {
      type: String,
      required: true,
    },
    badgeColor: {
      type: String,
      required: true,
      default: 'success'
    },
    description: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    },
    error: {
      type: Boolean,
      required: true,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.card-dashboard {
  display: flex;
  min-width: 19rem;
  justify-content: center;
  height: 100%;
  position: relative;
  flex-direction: column;
  gap: 1.5rem;
  line-height: 18px;
  padding: 1rem 0;
  border-radius: 0.75rem;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 2px solid #e2e8f0;
  background: linear-gradient(to bottom right, #f8fafc, #f1f5f9);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  .card-dashboard-badge {
    color: #059669;
    background-color: #d1fae5;
  }

  &:hover {
    border-color: #abe9c9;

    .card-dashboard-icon {
      border-color: #abe9c9;
    }
  }
}

.card-dashboard.danger {
  &:hover {
    border-color: #f8d7da;

    .card-dashboard-icon {
      border-color: #f8d7da;
    }
  }

  .card-dashboard-badge {
    color: #e53e3e;
    background-color: #f8d7da;
  }

}

.card-dashboard.loading {
  border: 2px solid #e2e8f0;
  background: #e4e6ebb2;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.card-dashboard.loading:hover {
  transform: scale(1);
  cursor: not-allowed;
}

.card-dashboard:hover {
  transform: scale(1.05);
  cursor: pointer;
}

.card-dashboard-content {
  padding: 1rem;
}

.card-dashboard-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.card-dashboard-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.75rem;
  background-color: #F5F6FC;
  border: 1px solid #cbd5e1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475569;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.icon {
  width: 1.25rem;
  height: 1.25rem;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.card-dashboard-info {
  flex: 1;
  min-width: 0;
}

.card-dashboard-title-row {
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-dashboard-title {
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #1d58b7;
  letter-spacing: 0.05em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-dashboard-badge {
  height: 1.125rem;
  padding: 0px 0.25rem;
  position: absolute;
  top: 7px;
  right: 7px;
  font-size: 0.625rem;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-dashboard-value {
  text-align: center;
  font-size: 1.25rem;
  font-weight: 700;
  color: #4c4e51;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 0;
  text-overflow: ellipsis;
}

.card-dashboard-subtext {
  text-align: center;
  font-size: 1rem;
  color: #94a3b8;
  /* white-space: nowrap; */
  overflow: hidden;
  margin-bottom: 0;
  text-overflow: ellipsis;
}
</style>
